// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let FileList = require("../../common/Components/FileList.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardRelayPreviewFiles_previewHelpers_graphql = require("../../../__generated__/PropertyWizardRelayPreviewFiles_previewHelpers_graphql.bs.js");

let convertFragment = PropertyWizardRelayPreviewFiles_previewHelpers_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewFiles_previewHelpers_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewFiles_previewHelpers_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewFiles_previewHelpers_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewFiles_previewHelpers_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__Preview__Files(props) {
  let displayHelpers = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewFiles_previewHelpers_graphql.node, convertFragment, props.displayHelpers);
  let files = displayHelpers.files;
  let files$1 = files !== undefined ? files.map(f => f.fragmentRefs) : [];
  return JsxRuntime.jsx(FileList.make, {
    files: files$1
  });
}

let make = PropertyWizardRelay__Preview__Files;

exports.Fragment = Fragment;
exports.make = make;
/* FileList Not a pure module */
